// extracted by mini-css-extract-plugin
export default {"header":"Header_header__pW-+N","section":"Header_section__Uejia","section_item":"Header_section_item__xj2wj","name":"Header_name__dy2np","dot":"Header_dot__7ZrEN"};